import { CanvasJSChart } from 'app/components/CanvasJs';
import React from 'react';
import { coresGestaoEnvio } from './styles';

const GestaoEnvioGraficoOrigem = ({ values }) => {
  return (
    <CanvasJSChart
      options={{
        culture: 'pt-br',
        animationEnabled: true,
        axisY: {
          labelFontSize: 11,
        },
        toolTip: {
          shared: true,
        },
        legend: {
          fontSize: 16,
          cursor: 'pointer',
          verticalAlign: 'bottom',
        },
        data: [
          {
            type: 'doughnut',
            showInLegend: true,
            dataPoints: [
              {
                y: values.somatorioOrcamento || 0,
                color: coresGestaoEnvio.verde_amarelado,
                legendText: 'Orçamento',
              },
              {
                y: values.somatorioCobranca || 0,
                color: coresGestaoEnvio.azul,
                legendText: 'Cobrança',
              },
              {
                y: values.somatorioOrdemServico || 0,
                color: coresGestaoEnvio.verde,
                legendText: 'Ordem de serviço',
              },
              {
                y: values.somatorioReguaCobranca || 0,
                color: coresGestaoEnvio.laranja,
                legendText: 'Régua de cobrança',
              },
              {
                y: values.somatorioNotaFiscal || 0,
                color: coresGestaoEnvio.roxo,
                legendText: 'Nota fiscal',
              },
            ],
          },
        ],
      }}
    />
  );
};

export default GestaoEnvioGraficoOrigem;
